import { styled } from "@mui/material/styles";

export const IconWrapper = styled("div")({
  cursor: "pointer",
});
